	import { Injectable } from '@angular/core';
	import { HttpClient } from '@angular/common/http';
	import { BehaviorSubject, Observable, Subject } from 'rxjs';
	import { User, Role } from '../../auth/models';
	import { ToastrService } from 'ngx-toastr';
	import { RestApiService } from '../../../../src/app/rest-api.service';
	import { environment } from '../../../environments/environment';
	import { map } from 'rxjs/operators';
	import { CommonService } from './common.service';
	import * as CryptoJS from 'crypto-js';

	@Injectable({ providedIn: 'root' })
	export class AuthenticationService {
	//public
	public currentUser: Observable<User>;
	private refreshNavbar$ = new Subject<any>();
	refreshNavbar = this.refreshNavbar$.asObservable();
	//private
	public currentUserSubject: BehaviorSubject<User>;
	public key: any;
	public iv: any;
	/**
	 *
	 * @param {HttpClient} _http
	 * @param {ToastrService} _toastrService
	 */
	constructor(private _http: HttpClient, private _toastrService: ToastrService, private commonService: CommonService,
		 public api: RestApiService) {
			this.currentUserSubject = new BehaviorSubject<User>(this.currentUserValue);
			this.currentUser = this.currentUserSubject.asObservable();
			this.key = environment.cryptoJSKey;
			this.iv  = environment.cryptoJSIV;
	}

	// getter: currentUserValue
	public get currentUserValue(): User {
		return this.currentUserSubject?.value;
	}

	/**
	 *  Confirms if user is admin
	 */
	get isAdmin() {
		return this.currentUser && this.currentUserSubject.value.role === Role.Admin;
	}

	/**
	 *  Confirms if user is export
	 */
	get isExpert() {
		return this.currentUser && this.currentUserSubject.value.role === Role.Expert;
	}

	/**
	 *  Confirms if user is user
	 */
	get isUser() {
		return this.currentUser && this.currentUserSubject.value.role === Role.User;
	}

	// get isApplyonline() {
	// 	return this.currentUser && this.currentUserSubject.value.isApplyonline === ;
	// }
	/*** User login **/
	login(email: string, password: string) {
		//return this.api.post("/auth/login", { 'email': email, 'password': password });
		return this._http
		.post<any>(`${environment.apiUrl}/auth/login`, { email, password })
		.pipe(
			map(userdata => {
			// login successful if there's a jwt token in the response
			let user = userdata["data"]["response"];
			if (user && user.token) {
				// store user details and jwt token in local storage to keep user logged in between page refreshes
				localStorage.setItem('token', user.token);
				if(CryptoJS.HmacSHA256(Role.Admin, this.key).toString() == user.role)
				{
					user.role = Role.Admin.toString();
				}
				else if(CryptoJS.HmacSHA256(Role.Expert, this.key).toString() == user.role)
				{
					user.role = Role.Expert.toString();
				}
				else if(CryptoJS.HmacSHA256(Role.User, this.key).toString() == user.role)
				{
					user.role = Role.User.toString();
				}
				//sessionStorage.setItem("currentUser", JSON.stringify(user));
				this.currentUserSubject.next(user);
			}

			return user;
			})
		);
	}

	/*** User logout**/
	logout() {
		this.api.post("/auth/logout", {}).subscribe((result: any) => {});
		localStorage.removeItem('token');
		this.currentUserSubject.next(null);
		window.location.reload();
	}

	/*** User registration **/
	registration(data) {
		return this.api.post("/auth/register", data);
	}

	sendForgotPasswordLink(data){
		return this.api.post("/auth/sendForgotPasswordLink", data);
	}

	updatePassword(data) {
		return this.api.post("/auth/resetPassword", data);
	}

	getUserProfileData(){
		return new Promise((resolve, reject) => {
			this.api.post("/getProfileData", {}).subscribe((result: any) => {
				let user = result.data.response;
				if(CryptoJS.HmacSHA256(Role.Admin, this.key).toString() == user.role)
				{
					user.role = Role.Admin.toString();
				}
				else if(CryptoJS.HmacSHA256(Role.Expert, this.key).toString() == user.role)
				{
					user.role = Role.Expert.toString();
				}
				else if(CryptoJS.HmacSHA256(Role.User, this.key).toString() == user.role)
				{
					user.role = Role.User.toString();
				}
				this.currentUserSubject.next(user);
				resolve(user)
			});
		}) 
	}

	refreshNavbarMenu() {
		this.refreshNavbar$.next(true);
	}
}
